import React from 'react'
import ProofComma from '../../../../../assets/images/proof-c.png'
import ProofOne from '../../../../../assets/images/proof-1.png'
import ProofTwo from '../../../../../assets/images/proof-2.png'
import ProofThree from '../../../../../assets/images/proof-3.png'
import SocialProof from "../Schedule/Components";

export const SocialProofView = () => {
  const proofs = [
    {
      cover: ProofComma,
      comment: '“MeetOcto has completely simplified how my team schedules meetings. No more endless back-and-forth emails!”',
      userImg: ProofOne,
      userName: 'Sarah Lopez',
      userJob: 'Marketing Manager',
    },
    {
      cover: ProofComma,
      comment: '“I love how easy it is to see everyone’s availability. MeetOcto saves me so much time every week.”',
      userImg: ProofTwo,
      userName: 'James Patel',
      userJob: 'Product Designer',
    },
    {
      cover: ProofComma,
      comment: '“Our team’s productivity has skyrocketed since we started using MeetOcto. Scheduling has never been this smooth!”',
      userImg: ProofThree,
      userName: 'Michael Chen',
      userJob: 'Sales Lead',
    },
  ]
  return (
    <div className="social-proof wrapper">
      <h1 className="heading pb-2">Social Proof</h1>
      <div className="row">
        {proofs.map((proof, index) => (
          <SocialProof proofs={proof} key={index}/>
        ))}
      </div>
    </div>
  )
}

